import { Stack, Typography } from "@mui/material";

type Props = {
  title: string;
};

const Header: React.FC<Props> = ({ title }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h5" fontWeight={600} color="primary.dark">
        {title}
      </Typography>
    </Stack>
  );
};
export default Header;
